import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CalendarModule } from 'primeng/calendar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';

@NgModule({
  imports: [
    CommonModule,
    CalendarModule,
    ScrollPanelModule,
    TableModule
  ],
  exports: [
    CalendarModule,
    ScrollPanelModule,
    TableModule
  ]
})
export class AppPrimeNgModule { }
